<template>
  <div class="w-full group overflow-hidden relative">
    <div class="w-full h-full absolute inset bg-white-80 hidden group-hover:block" v-if="mode === 'edit'" @click="openMediaManager">
      <div class="flex flex-col items-center justify-center h-full cursor-pointer">
        <i class="fas fa-image text-5xl mb-3"></i>
        <span>Change Image</span>
      </div>
    </div>
    <img :src="content.image" class="block w-full h-48 object-cover" />
    <ezine-media-manager ref="mediaManager" :assignable-id="selectedOffice.client_id" @selected="content.image = $event" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EzineMediaManager from '../EzineMediaManager.vue'

export default {
  components: {
    EzineMediaManager
  },
  props: {
    value: Object,
    mode: String
  },
  computed: {
    ...mapState(['selectedOffice']),
    content: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    openMediaManager () {
      this.$refs.mediaManager.open()
    }
  }
}
</script>

<style>
.bg-white-80 {
  background-color: rgba(255, 255, 255, 0.8);
}
</style>
